import { useState } from 'react'
import { InvoiceTimeline } from '@/components/invoices/InvoiceTimeline'
import { useIsAdmin } from '@/lib/auth'
import { useAddComment } from '@/lib/invoice-queries'
import type { Invoice } from '@/lib/invoice-types'

export function ActivityTab({ invoice }: { invoice: Invoice }) {
  const canComment = useIsAdmin()
  const [body, setBody] = useState('')
  const addComment = useAddComment(invoice.id)

  function submit() {
    const trimmed = body.trim()
    if (!trimmed) return
    addComment.mutate(trimmed)
    setBody('')
  }

  return (
    <div className="space-y-4">
      <InvoiceTimeline events={invoice.events} comments={invoice.comments} />

      {canComment ? (
        <div className="flex items-center gap-2 border-t border-hairline pt-4">
          <input
            type="text"
            value={body}
            onChange={(e) => setBody(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault()
                submit()
              }
            }}
            placeholder="Plaats een reactie…"
            className="field"
          />
          <button type="button" className="btn-primary shrink-0" onClick={submit} disabled={!body.trim()}>
            Plaats
          </button>
        </div>
      ) : null}
    </div>
  )
}
